import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';
import AppProviders from './providers/AppProviders.jsx';
import { configureAmplify } from './auth/configureAmplify.js';
import './index.css';

// Configure Amplify once, before anything renders or opens a socket, so auth and
// the WebSocket transport see a fully configured Cognito provider from first
// paint.
configureAmplify();

const container = document.getElementById('root');

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
